import { render } from "./MobileHeader.vue?vue&type=template&id=3bd35eac&ts=true"
import script from "./MobileHeader.vue?vue&type=script&lang=ts"
export * from "./MobileHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__